import { makeStyles } from '@material-ui/core/styles';
import colors from 'global/styles/colors';

const useStyles = makeStyles((theme) => ({
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    width: '100%',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    position: 'relative',
    padding: theme.spacing(4),
    maxWidth: 900,
    margin: '0 auto',
  },
  fullWidth: {
    width: '100%',
  },
  innerContainer: {
    padding: `0 ${theme.spacing(4)}px`,

    '& h6': {
      fontSize: 14,
    },

    '& .MuiCheckbox-root': {
      padding: 1,
    },
    '& .MuiFormControlLabel-root': {
      marginLeft: 0,
    },
  },
  editButton: {
    marginTop: theme.spacing(1),
  },
  realmContainer: {
    position: 'relative',
    borderTop: `1px solid black`,
    margin: `${theme.spacing(2)}px 0`,
  },
  realm: {
    padding: theme.spacing(1),
    position: 'relative',
    borderBottom: `1px solid black`,
  },
  delete: {
    position: 'absolute',
    top: 5,
    right: 5,
    color: colors.danger,
  },
  hideBorders: {
    borderBottom: 'none',
    borderTop: 'none',
  },
  italic: {
    fontStyle: 'italic',
  },
}));

export const tradeStyles = makeStyles(theme => ({
  header: {
    borderBottom: `2px solid ${theme.palette.grey[200]}`,
  },
  row: {
    padding: `${theme.spacing(0.5)}px 0`,
  },
  cell: {
    fontSize: 12,
  }
}))

export default useStyles;
